module.exports = __webpack_public_path__ + "img/none-icon-svg.a2f95e99.svg";